module.exports = __webpack_public_path__ + "static/media/defrag_2.914fe4c1.ico";